export function useUrlParam() {
    const get = (paramName: string): string | null => {
        const url = new URL(window.location.href);
        return url.searchParams.get(paramName);
    };

    return {
        get,
    };
}